import React, { useState, useEffect } from 'react'
import { useFormik } from "formik";
import { formatDate } from '../../utils/dateUtils';
import { userRequest } from '../../utils/requestMethods';
//import { useStateContext } from '../../contexts/ContextProvider';
import ButtonLoading from '../ButtonLoading';
import { informationSchema } from '../../utils/formSchema';

const Information = ({ setRefresh, schoolData }) => {
    //const { school } = useStateContext();
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    console.log(schoolData);

    useEffect(() => {
        if (schoolData && formik) {
            formik.setValues({
                ...schoolData,
                date_of_registration: formatDate(schoolData?.date_of_registration),
            });
        }
    }, [schoolData]);
    

    const formik = useFormik({
        initialValues: {
            school_name: schoolData?.school_name || '',
            phone_number: schoolData?.phone_number || '',
            bvn: schoolData?.bvn || '',
            date_of_registration: schoolData?.date_of_registration || '',
            registration_type: schoolData?.registration_type || '',
            industry: schoolData?.industry || '',
            description: schoolData?.description || '',
        },
        validationSchema: informationSchema,
        onSubmit: (values) => {
            registerHandler(values);
            console.log(values);
        },
    });

    console.log(formik.values);

    const registerHandler = async (values) => {
        setLoading(true);
        try {
            const allValues = {
                ...values,
                date_of_registration: formatDate(formik.values.date_of_registration),
            };
            await userRequest.put(`/schools/${schoolData._id}`, {
                //allValues,
                school_name: allValues.school_name,
                phone_number: allValues.phone_number,
                bvn: allValues.bvn,
                date_of_registration: allValues.date_of_registration,
                registration_type: allValues.registration_type,
                industry: allValues.industry,                
                description: allValues.description,
                
            });

            setSuccess("Business Information added");
            setTimeout(() => {
                setSuccess("");
                setRefresh("information");
                //navigate("/auth/kyc");
            }, 2000);
        } catch (error) {
            console.log(error);
            setError("Something went wrong, try again in a few minutes!");
            setTimeout(() => {
                setError("");
            }, 5000);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="bg-white border border-gray-200 rounded-3xl shadow">
            <div className="items-right">
                <div className="m-3 p-5 divide-y">
                    {success &&
                        <div className="alert alert-success d-flex align-items-center" role="alert">
                            <i className="fal fa-check pr-10"></i>
                            <div>
                                {success}
                            </div>
                        </div>
                    }
                    {error && 
                        <div className="alert alert-warning d-flex align-items-center" role="alert">
                            <i className="fal fa-lock pr-10"></i>
                            <div>
                                {error}
                            </div>
                        </div>
                    }
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid grid-cols-1 gap-6">
                            <div>
                                <div className="lg:grid lg:grid-cols-2 lg:gap-x-2">
                                    <div className="mb-2">
                                        <span className="text-gray-700 dark:text-gray-200">Business Name</span>
                                        <input type="text" id="school_name" name="school_name" placeholder="Legal Business Name" value={formik.values.school_name} onBlur={formik.handleBlur} onChange={formik.handleChange} className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0"/>
                                        {formik.errors.school_name && formik.touched.school_name &&
                                            <p className="mt-2 text-sm text-red-600 dark:text-red-500">{formik.errors.school_name}</p>}
                                    </div>
                                    <div className="mb-2">
                                        <span className="text-gray-700 dark:text-gray-200">Business Phone Number</span>
                                        <input type="text" id="phone_number" name="phone_number" placeholder="Business Phone Number" value={formik.values.phone_number} onBlur={formik.handleBlur} onChange={formik.handleChange} className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0" />
                                        {formik.errors.phone_number && formik.touched.phone_number &&
                                            <p className="mt-2 text-sm text-red-600 dark:text-red-500">{formik.errors.phone_number}</p>}
                                    </div>
                                </div>
                            </div>
                            <label className="block">
                                <span className="text-gray-700 dark:text-gray-200">Business BVN <small>Business officier/signatory</small></span>
                                <input type="text" placeholder='BVN' id="bvn" value={formik.values.bvn} onBlur={formik.handleBlur} onChange={formik.handleChange} className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0" />
                                {formik.errors.bvn && formik.touched.bvn &&
                                    <p className="mt-2 text-sm text-red-600 dark:text-red-500">{formik.errors.bvn}</p>}
                            </label>
                            <div>
                                <p className="text-gray-700 dark:text-gray-200 mb-2">Business Category and Registration Type</p>
                                <div className="lg:grid lg:grid-cols-2 lg:gap-x-2">
                                    <div className="mb-2">
                                        <select id="industry" value={formik.values.industry} onBlur={formik.handleBlur} onChange={formik.handleChange} className="bg-gray-100 border-gray-100 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                                            <option value="">Business Category</option>
                                            <option value="Education-NurserySchools">Education - Nursery Schools</option>
                                            <option value="Education-PrimarySchools">Education - Primary Schools</option>
                                            <option value="Education-SecondarySchools">Education - Secondary Schools</option>
                                            <option value="Education-TertiaryInstitutions">Education - Tertiary Institutions</option>
                                            <option value="Education-OtherEducationalServices">Education - Other EducationalServices</option>
                                        </select>
                                        {formik.errors.industry && formik.touched.industry &&
                                            <p className="mt-2 text-sm text-red-600 dark:text-red-500"> {formik.errors.industry}</p>}
                                    </div>
                                    <div className="">
                                        <select id="registration_type" value={formik.values.registration_type} onBlur={formik.handleBlur} onChange={formik.handleChange} className="bg-gray-100 border-gray-100 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
                                            <option value="">Business Registration Type</option>
                                            <option value="Private_Incorporated">Private Incorporated</option>
                                            <option value="Incorporated_Trustees">Incorporated Trustees</option>
                                            <option value="Business_Name">Business Name</option>
                                            <option value="Free_Zone">Free Zone</option>
                                            <option value="Cooperative_Society">Cooperative Society</option>
                                            <option value="Public_Incorporated">Public Incorporated</option>
                                        </select>
                                        {formik.errors.registration_type && formik.touched.registration_type &&
                                            <p className="mt-2 text-sm text-red-600 dark:text-red-500"> {formik.errors.registration_type}</p>}
                                    </div>
                                </div>
                            </div>
                            
                            <label className="block">
                                <span className="text-gray-700 dark:text-gray-200">Date of Registration</span>
                                <input type="date" id="date_of_registration" value={formik.values.date_of_registration} onBlur={formik.handleBlur} onChange={formik.handleChange} className="mt-1 block w-full rounded-md bg-gray-100 border-transparent focus:border-gray-500 focus:bg-white focus:ring-0" />
                                {formik.errors.date_of_registration && formik.touched.date_of_registration &&
                                    <p className="mt-2 text-sm text-red-600 dark:text-red-500"> {formik.errors.date_of_registration}</p>}
                            </label>
                            <label className="block">
                                <p className="text-gray-700 dark:text-gray-200">About your School</p>
                                <textarea id="description" value={formik.values.description} onBlur={formik.handleBlur} onChange={formik.handleChange} placeholder="Business Description" rows="4" className="block p-2.5 w-full text-sm text-gray-900 bg-gray-100 rounded-lg border border-gray-100 focus:ring-blue-500 focus:border-blue-500"></textarea>
                                {formik.errors.description && formik.touched.description &&
                                    <p className="mt-2 text-sm text-red-600 dark:text-red-500"> {formik.errors.description}</p>}
                            </label>
                            <div className="px-4 py-3 text-right sm:px-6">
                                {loading ?
                                    (
                                        <ButtonLoading styles="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-md font-medium rounded-full text-white bg-indigo-800" />
                                    ) : (
                                        <button type="submit" className="inline-flex justify-center py-2 px-8 border border-transparent shadow-sm text-md font-medium rounded-full text-white bg-indigo-800 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Save Details</button>
                                    )
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Information
